import { DownTimePlannedCategoryenum, StEnum } from "@gtpl/shared-models/common-models";
import { BaseEntity, Column, Entity, Index, JoinColumn, JoinTable, ManyToMany, ManyToOne, OneToMany, PrimaryColumn, PrimaryGeneratedColumn, RelationId, UpdateDateColumn, CreateDateColumn, VersionColumn } from "typeorm";
import { CategoryEnum } from "@gtpl/shared-models/common-models";
import { DownTimeTrackingStatusEnum } from "@gtpl/shared-models/common-models";
import { type } from "os";
@Entity('downtime_tracking')
export class DownTimeTracking {
  @PrimaryGeneratedColumn("increment", { name: 'downtimeTreacking_id' })
  downtimeTrackingId: number;

  @Column("int", {
    name: "department_Id",
    nullable: true,
  })
  departmentId: number;

  @Column({
    type: "enum",
    enum: CategoryEnum,
    nullable: true,
    name: "category",

  })
  category: CategoryEnum;


  @Column({
    name: "startTime",
    type: "datetime",
    nullable: false
  })
  startTime: Date;
  

  @Column({
    name: "reason_Id",
    type: "int",
    nullable: true,
  })
  reasonId: number;

  @Column({
    name: "asset_id",
    type: "int",
    nullable: false,
  })
  assetId: number;

  @Column({
    type: "enum",
    nullable: true,
    name: "status",

    enum: DownTimeTrackingStatusEnum,
    default: DownTimeTrackingStatusEnum.OPEN
  })
  status: DownTimeTrackingStatusEnum;

  @Column({
    type: "enum",
    nullable: false,
    name: "downtime_type",
    enum: DownTimePlannedCategoryenum,
    default: DownTimePlannedCategoryenum.UN_PLANNED,
  })
  downtimetype: DownTimePlannedCategoryenum;

  @Column({
    type: "datetime",
    nullable: true,
    name: "expected_planned_time"
  })
  plannedtime: Date;

  @Column({
    name: "no_of_resources",
    nullable: true,
    type: "int"
  })
  resources: number;

  @Column({
    name: "endtime",
    nullable:true,
    type: "datetime"
  })
  endtime: Date;

  @Column("varchar", {
    nullable: true,
    name: "impact",
    length: 100,
  })
  impact: string;

  @Column("varchar", {
    nullable: true,
    name: "remarks",
    length: 100,
  })
  remarks: string;

  @Column("int", {
    nullable: true,
    name: "saleorder_Id"
  })
  saleorderId: number;


  @Column("varchar", {
    nullable: true,
    name: "machine_name",
    length: 100,
  })
  machineName: string;

  @Column("varchar", {
    nullable: true,
    name: "machine_code",
    length: 100,
  })
  machineCode: string;
  
  @Column("varchar", {
    nullable: true,
    name: "resolution",
    length: 100,
  })
  resolution: string;


  @Column("int", {
    name: "employee_id",
    nullable: true,

  })
  employeeId: number;

  @Column("boolean", {
    nullable: false,
    default: true,
    name: "is_active"
  })
  isActive: boolean;

  @CreateDateColumn({
    name: "created_at",
    type: "datetime",
    nullable: false
  })
  createdAt: Date;

  @Column("varchar", {
    nullable: false,
    default: 1,
    name: "created_user",
    length: 100

  })
  createdUser: string | null;


  @UpdateDateColumn({
    name: "updated_at",
    nullable: true,
    type: 'datetime'
  })
  updatedAt: Date;

  @Column("varchar", {
    nullable: true,
    name: "updated_user",
    length: 100
  })
  updatedUser: string | null;

  @Column("int", {
    nullable: false,
    name: "unit_id"
  })
  unitId: number;
  
  @VersionColumn({
    default: 1,
    name: "version_flag"
  })
  versionFlag: number;

  @Column("int", {
    name: "asset_category_id",
    nullable: true,

  })
  assetCategoryId: number;


}
